import React from "react";
import "./HeaderItem.css";

import { Link } from "react-router-dom";



const HeaderItem = ({ id, mainLink, subLink }) => {

  return (
    <div className="nav-item" key={id}>

      {/* Dropdown Menu - Main navigation button */}
      <div className="dropdown-menu">
        {subLink.length > 0 ? (
          <div className="nav-btn">{mainLink.title}</div>
        ) : (
          <Link className="nav-btn" to={mainLink.link}>
            {mainLink.title}
          </Link>
        )}
      </div>

      {/* Dropdown Content - Display sub-links if available */}
      {subLink.length > 0 && (
        <div className="dropdown-content">
          {subLink.map((item) => (
            <div key={item.id} className="dropdown-item">
              <Link to={item.link} state={item.state}>
                {item.title}
              </Link>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default HeaderItem;